@if (useFastIconType) {
    <vn-menu-item
        [item]="item"
        [section]="MenuSection.NewVisitorPage"
        [displayMode]="MenuDisplayMode.FastIcon"
        [processClick]="false"
        (click)="processClick($event, item)" />
} @else {
    <vn-menu-item
        [item]="item"
        [section]="MenuSection.NewVisitorPage"
        [displayMode]="MenuDisplayMode.Icon"
        [processClick]="false"
        (click)="processClick($event, item)" />
}
